import { render, staticRenderFns } from "./EspaceHeader.vue?vue&type=template&id=4fbbf4f6&scoped=true&"
import script from "./EspaceHeader.vue?vue&type=script&lang=js&"
export * from "./EspaceHeader.vue?vue&type=script&lang=js&"
import style0 from "./EspaceHeader.vue?vue&type=style&index=0&id=4fbbf4f6&prod&lang=scss&scoped=true&"
import style1 from "./EspaceHeader.vue?vue&type=style&index=1&id=4fbbf4f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbbf4f6",
  null
  
)

export default component.exports